<template>
    <div>
        <minhas-licitacoes-titulo-secao titulo="Minhas Propostas"/>
        <minhas-licitacoes-tabela :itens="itens" :paginas="paginas" :total-itens="totalItens"
                                  :paginacao="$store.state.licitacoesFornecedorComProposta.paginacao"
                                  @paginar="eventoPaginar"
                                  @visualizar="eventoVisualizar" @acaoPrincipal="eventoAcaoPrincipal"/>
    </div>
</template>

<script>
    import {mapActions, mapMutations} from 'vuex'
    import {actionTypes, mutationTypes} from '@/commons/constants'
    import MinhasLicitacoesTabela from './MinhasLicitacoesTabela'
    import MinhasLicitacoesTituloSecao from './MinhasLicitacoesTituloSecao'

    export default {
        name: 'MinhasLicitacoesComProposta',
        components: {MinhasLicitacoesTituloSecao, MinhasLicitacoesTabela},
        data() {
            return {
                itens: [],
                paginas: 0,
                totalItens: 0
            }
        },
        methods: {
            ...mapActions([actionTypes.BUSCAR_LICITACOES_FORNECEDOR_COM_PROPOSTA]),
            ...mapMutations([mutationTypes.SET_PAGINACAO_BUSCA_LICITACOES_COM_PROPOSTA_FORNECEDOR]),
            async buscar() {
                this.setMensagemLoading('Carregando Licitações...')
                const resultado = await this.buscarLicitacoesFornecedorComProposta()
                this.itens = resultado.content
                this.paginas = resultado.totalPages
                this.totalItens = resultado.totalElements
            },

            isCredenciamentoComSolicitacao(licitacao) {
              return licitacao.modalidade === 'CREDENCIAMENTO' && licitacao.enviada;
            },

            isCredenciamentoSemSolicitacao(licitacao) {
              return licitacao.modalidade === 'CREDENCIAMENTO' && !licitacao.enviada;
            },

            eventoAcaoPrincipal(licitacao) {

              if (!this.podeAcessarPregao(licitacao)) {
                    this.$router.push({name: 'licitacaoFornecedorProposta', params: {id: licitacao.id}})
                } else if (this.isCredenciamentoComSolicitacao(licitacao)) {
                  this.$router.push({name: 'CredenciamentoFornecedorResultado', params: {id: licitacao.id}})
                } else if (this.isCredenciamentoSemSolicitacao(licitacao)) {
                  this.$router.push({name: 'credenciamentoFornecedorDocumentos', params: {id: licitacao.id}})
                } else {
                    this.acessarPregao(licitacao)
                }
            },
            eventoPaginar(paginacao) {
                this.setPaginacaoBuscaLicitacoesComPropostaFornecedor(paginacao)
                this.buscar()
            },
            eventoVisualizar(licitacao) {
              if (licitacao.modalidade === 'CREDENCIAMENTO'){
                this.$router.push({name: 'credenciamentoFornecedor', params: {id: licitacao.id}})
              }else{
                this.$router.push({name: 'licitacaoFornecedor', params: {id: licitacao.id}})
              }
            }
        }
    }
</script>